module.exports = __webpack_public_path__ + "img/3-6.277040b3.png";